import { V4 } from '@moleculeone/utils';

import { getSmallestCycles } from './selectors';

export default class Cycler {
  constructor(factor) {
    this.factor = factor;
  }

  apply(mol, forces, cycles = getSmallestCycles(mol)) {
    const positions = mol.positions;
    const { distinctCycles } = cycles;

    for (const cycle of Object.values(distinctCycles)) {
      const length = cycle.length;
      if (length > 7) {
        continue;
      }

      const angleData = [];
      let startIndex = cycle[cycle.length - 2];
      let centerIndex = cycle[cycle.length - 1];
      let directions = 0;
      for (let i = 0; i < cycle.length; i++) {
        const endIndex = cycle[i];
        const centerPos = positions[centerIndex];
        const endVect = V4.sub(positions[endIndex], centerPos);
        const startVect = V4.sub(positions[startIndex], centerPos);
        const angle = V4.angleZ(endVect, V4.scale(startVect, -1));
        angleData.push([startIndex, centerIndex, endIndex, startVect, endVect, angle]);
        directions += Math.sign(angle);
        startIndex = centerIndex;
        centerIndex = endIndex;
      }

      if (Math.abs(directions) !== length) {
        continue;
      }

      for (const [startIndex, centerIndex, endIndex, startVect, endVect, angle] of angleData) {
        const descent = (Math.sign(directions) * 2 * Math.PI) / length - angle;
        const startForce = V4.normal(V4.rotZ(startVect, -Math.PI / 2.0), this.factor * descent);
        const endForce = V4.normal(V4.rotZ(endVect, Math.PI / 2.0), this.factor * descent);

        forces[startIndex].push(startForce);
        forces[endIndex].push(endForce);
        forces[centerIndex].push(V4.scale(startForce, -1));
        forces[centerIndex].push(V4.scale(endForce, -1));
      }
    }
  }
}
